import type { ValidationErrors } from '../../../../../utils/validation';
import type { ICustomControlData } from './customControlData';
import { TcohProcedureType } from '../../../../../../common/enums/tcohProcedureType';
import { translateKey } from '../../../../../translate';
import { RadioGroupField } from '../../../../fields/RadioGroup';

interface IProcedureTypeAddEditProps {
    customControlData: ICustomControlData;
    errors: ValidationErrors;
    handleChangeCustomControl: (customControl: Partial<ICustomControlData>) => Promise<void>;
}

export function ProcedureTypeAddEdit(props: IProcedureTypeAddEditProps) {
    return (
        <RadioGroupField
            automation="procedureType"
            error={props.errors.get('customControlData.procedureType')}
            fieldKey="procedureType"
            hasErrors={props.errors.has('customControlData.procedureType')}
            isRequired
            label="Type onderzoek"
            onChange={async (value) => {
                // Clear state of admissionDuration combobox in case of procedure type change
                await props.handleChangeCustomControl({
                    eventEcgCardioExaminationDuration: null,
                    holterCardioExaminationDuration: null,
                    procedureType: translationToProcedureType(value),
                });
            }}
            options={[
                procedureTypeToTranslation(TcohProcedureType.holter),
                procedureTypeToTranslation(TcohProcedureType.eventEcg),
            ]}
            value={
                props.customControlData.procedureType
                    ? procedureTypeToTranslation(props.customControlData.procedureType)
                    : null
            }
        />
    );
}

function translationToProcedureType(value: string) {
    return value === procedureTypeToTranslation(TcohProcedureType.holter)
        ? TcohProcedureType.holter
        : TcohProcedureType.eventEcg;
}

function procedureTypeToTranslation(value: TcohProcedureType) {
    return value === TcohProcedureType.holter
        ? translateKey(`tcohProcedureTypeEnum.${TcohProcedureType.holter}`)
        : translateKey(`tcohProcedureTypeEnum.${TcohProcedureType.eventEcg}`);
}
